import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StaffLoginService } from 'src/app/services/staff-login/staff-login.service';

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss']
})
export class LogInComponent implements OnInit {
  passConfirmationForm: FormGroup;

  current_date = new Date();
  resetPassSelectedIndex: any = 0;
  selectedIndex: any = 0;
  reset_mobile_email: FormControl = new FormControl('', Validators.required);
  otp_ctrl: FormControl = new FormControl('', Validators.required);
  verify_otp_error_msg: string = '';
  verify_otp_success_msg: string = '';
  verify_otp_response: any;
  otp_response: any;
  pass_update_response: any;
  otp_error_msg: string = '';
  current_url: string = '';
  update_pass_error_msg: string = '';

  is_access_authorised: boolean = false;
  is_reset_password: boolean = false;
  show_otp_filed: boolean = false;
  is_passReset: boolean = false;
  is_verifyingOtp: boolean = false;

  private onDestroy = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private staffLoginService: StaffLoginService,
    private router: Router,
  ) {
    router.events.pipe(takeUntil(this.onDestroy)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.current_url = event.urlAfterRedirects;
        if (this.current_url.includes('/reset-password')) {
          this.selectedIndex = 1;
        };
      };
    });
  }

  ngOnInit(): void {
    this.passConfirmationForm = this.formBuilder.group({
      new_password: ['', [Validators.required]],
      confirm_password: ['', [Validators.required]]
    });
  }

  getToLoginPage() {
    this.selectedIndex = 0;
    // let control: AbstractControl = null;
    // this.loginForm.reset();
    // this.loginForm.markAsUntouched();
    setTimeout(() => {
      this.is_reset_password = false;
    }, 500);
    // Object.keys(this.loginForm.controls).forEach((name) => {
    //   control = this.loginForm.controls[name];
    //   control.markAsUntouched();
    // });
  }

  delete_cookie(cookie_name) {
    document.cookie = cookie_name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  changeForm() {
    this.selectedIndex = 1;
    this.is_reset_password = true;
  }
}
